module.exports = __webpack_public_path__ + "img/8D553D_3C2419_5D3727_AA766C-256px.d6d664ed.png";